"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _CreateNewPostsModal = _interopRequireDefault(require("./components/CreateNewPostsModal"));

var _DeleteConfirmationModal = _interopRequireDefault(require("./components/DeleteConfirmationModal"));

var _PublishConfirmationModal = _interopRequireDefault(require("./components/PublishConfirmationModal"));

var _EditPostModal = _interopRequireDefault(require("../../../../common/components/EditPostModal"));

var _FeaturedConfirmationModal = _interopRequireDefault(require("./components/FeaturedConfirmationModal"));

var _ReportPostModal = _interopRequireDefault(require("../../../../common/components/ReportPostModal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var ModalSwitcher = function ModalSwitcher(props) {
  var openedModalName = props.openedModalName,
      onClose = props.onClose,
      updateInspiration = props.updateInspiration,
      deleteInspiration = props.deleteInspiration,
      setPostFeatured = props.setPostFeatured,
      updatePostInState = props.updatePostInState,
      updatePostsInState = props.updatePostsInState,
      deletePostInState = props.deletePostInState,
      _props$modalPayload = props.modalPayload,
      modalPayload = _props$modalPayload === void 0 ? {} : _props$modalPayload,
      organisationId = props.organisationId;
  var _modalPayload$isPubli = modalPayload.isPublished,
      isPublished = _modalPayload$isPubli === void 0 ? false : _modalPayload$isPubli,
      _modalPayload$isFeatu = modalPayload.isFeatured,
      isFeatured = _modalPayload$isFeatu === void 0 ? false : _modalPayload$isFeatu,
      _modalPayload$postIdT = modalPayload.postIdToEdit,
      postIdToEdit = _modalPayload$postIdT === void 0 ? '' : _modalPayload$postIdT;
  return _react.default.createElement("div", null, _react.default.createElement(_CreateNewPostsModal.default, {
    modalVisible: openedModalName === 'createPosts',
    onToggleModal: onClose,
    organisationId: organisationId,
    updatePostsInState: updatePostsInState
  }), _react.default.createElement(_EditPostModal.default, {
    isVisible: openedModalName === 'editPost',
    onClose: onClose,
    inspirationId: postIdToEdit,
    onUpdated: updatePostInState
  }), _react.default.createElement(_DeleteConfirmationModal.default, {
    visible: openedModalName === 'deletePost',
    hideModal: onClose,
    deletePostInState: deletePostInState,
    deleteInspiration: deleteInspiration,
    inspirationId: postIdToEdit
  }), _react.default.createElement(_FeaturedConfirmationModal.default, {
    visible: openedModalName === 'setFeatured',
    isFeatured: isFeatured,
    hideModal: onClose,
    setPostFeatured: setPostFeatured,
    inspirationId: postIdToEdit
  }), _react.default.createElement(_PublishConfirmationModal.default, {
    visible: openedModalName === 'publishPost',
    hideModal: onClose,
    updatePostsInState: updatePostsInState,
    updateInspiration: updateInspiration,
    published: isPublished,
    inspirationId: postIdToEdit
  }), _react.default.createElement(_ReportPostModal.default, {
    visible: openedModalName === 'reportPost',
    inspirationId: postIdToEdit,
    onClose: onClose
  }));
};

var _default = ModalSwitcher;
exports.default = _default;